import cs from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import classes from './style.module.scss';

export default function Card({ children, className }) {
  return <div className={cs(classes.container, className)}>{children}</div>;
}

Card.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  className: PropTypes.string,
};

Card.defaultProps = {
  className: '',
};
